var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 output-html has-text-centered",staticStyle:{"width":"100%","height":"100px"},domProps:{"innerHTML":_vm._s(_vm.output)}})
}
var staticRenderFns = []

export { render, staticRenderFns }